<template>
  <el-dialog
    width="40%"
    class="dialog"
    title="分配归集仓"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
  >
    <el-form
      ref="ruleForm"
      label-position="right"
      :rules="rules"
      :model="formData"
      label-width="120px"
    >
      <el-form-item label="归集仓" prop="warehouseNo">
        <el-select
          v-model="formData.warehouseNo"
          placeholder="请选择"
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="item in warehouseOption"
            :key="item.warehouseNo"
            :label="item.warehouseName"
            :value="item.warehouseNo"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun"
        >保存</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { findAllWarehouseOption, warehouseAllocate } from "@/api/wareHouse";

export default {
  name: "setWarehouseDialog",
  components: {},
  data() {
    return {
      id: "",
      dialogFormVisible: false,
      warehouseOption: [], //归集仓选项列表
      warehouseOptionObj: {},
      formData: {
        provinceName: "",
        provinceCode: "",
        cityName: "",
        cityCode: "",
        warehouseNo: "",
        // warehouseName: "",
      },
      rules: {
        warehouseNo: [
          { required: true, message: "请选择归集仓", trigger: "blur" },
        ],
      },
      btnLoading: false,
    };
  },
  watch: {
    dialogFormVisible: function (val, oldVal) {
      if (!val) {
        this.$refs.ruleForm.resetFields();
      }
    },
  },
  async created() {
    this.findAllWarehouseOption();
  },
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dialogFormVisible = false;
    },
    // 打开弹框
    async openDialog(rowData) {
      this.formData.warehouseNo = null;
      let { provinceName, provinceCode, cityName, cityCode, warehouseNo } =
        rowData;
      this.formData = {
        provinceName,
        provinceCode,
        cityName,
        cityCode,
        warehouseNo,
      };
      this.dialogFormVisible = true;
    },
    // 确认提交
    submitBtnFun() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 保存和编辑数据接口
    async save() {
      let { statusCode, message } = await warehouseAllocate(this.formData);
      if (statusCode == 200) {
        this.$message.success("保存成功");
        this.$emit("opera-success");
        this.dialogFormVisible = false;
      } else {
        this.$message.error(message);
      }
    },
    // 表单重置
    resetFormStatus() {
      this.$refs.ruleForm.resetFields();
    },
    //获取归集仓选项
    async findAllWarehouseOption() {
      let { statusCode, data } = await findAllWarehouseOption();
      if (statusCode == 200) {
        this.warehouseOption = data;
        //转成对象用于返显示
        // this.warehouseOptionObj = this.warehouseOption.reduce((obj, item) => {
        //   obj[item.warehouseNo] = item.warehouseName;
        //   return obj;
        // }, {});
      }
    },
  },
};
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .tips {
    margin-bottom: 10px;
  }
  .el-dialog__body {
    padding-top: 10px;
  }
  .dialog-footer {
    padding: 20px;
    padding-top: 0;
  }
  .el-form-item--small.el-form-item {
    &.read-only {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/components/setWarehouseDialog.vue